<script setup lang="ts">
import type { IResponseData } from '~/types'
import type { IInsuranceTypes } from '~/components/widget/select-insurance-type/types'
import type { IInsuranceListProps as IProps } from '~/components/entity/insurance'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/insurance_types', { ...props.queryParams }))
const { data } = useApi<IResponseData<IInsuranceTypes[]>>(() => url, {
  key: 'insurance-types-sidebar-widget'
})
const insurances = computed(() => {
  return data.value?.data.map((i) => {
    return {
      title: i.title,
      url: `/insurances/${i.slug}`,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="insurances"
    :heading-text="$t('widget.select_insurance_type.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="insurances" />
  </SidebarBlock>
</template>
